
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 27 27"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.708 21.127L8.3 23.465a3.369 3.369 0 01-5.748-2.378c0-.892.355-1.748.986-2.379l6.177-6.184a3.349 3.349 0 014.612-.122l.163.136a1.362 1.362 0 002.314-.986 1.36 1.36 0 00-.41-.958 3.756 3.756 0 00-.244-.285 6.072 6.072 0 00-8.285.299l-6.258 6.184a6.085 6.085 0 00.178 8.425 6.097 6.097 0 008.433.178l2.354-2.297a1.358 1.358 0 00-.916-2.274 1.361 1.361 0 00-.948.303zM25.251 1.774a6.112 6.112 0 00-8.611 0L14.286 4.07a1.358 1.358 0 00.916 2.274c.343.022.682-.086.948-.304l2.354-2.337a3.369 3.369 0 015.747 2.378c0 .892-.355 1.748-.986 2.379l-6.176 6.184a3.349 3.349 0 01-4.612.122l-.164-.136a1.361 1.361 0 00-1.904 1.944c.099.1.203.196.313.285a6.085 6.085 0 008.285-.3l6.19-6.183a6.1 6.1 0 00.054-8.603z"}})])
          )
        }
      }
    